import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, throwError, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { RateLimitService } from '../services/common/rate-limit.service';

@Injectable()
export class RateLimitInterceptor implements HttpInterceptor {
  private readonly rateLimit = inject(RateLimitService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const readOnly = req.method === 'GET' || req.method === 'HEAD';
    const execute = () => next.handle(req);
    const currentCooldown = readOnly ? this.rateLimit.remainingMs() : 0;
    const initialRequest =
      currentCooldown > 0 ? timer(currentCooldown).pipe(switchMap(() => execute())) : execute();

    return initialRequest.pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status !== 429) return throwError(() => error);

        const retryAfter = this.rateLimit.activate(error);
        if (!readOnly) return throwError(() => error);

        const jitter = Math.floor(Math.random() * 250);
        return timer(retryAfter + jitter).pipe(
          switchMap(() => execute()),
          catchError((retryError: HttpErrorResponse) => {
            if (retryError.status === 429) this.rateLimit.activate(retryError);
            return throwError(() => retryError);
          }),
        );
      }),
    );
  }
}
